define('views/modules/conversation/message/reply-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    'services/user',
    // views
    'views/parts/menu/menu-context',
    'views/modules/supervisor/supervisor-icon',
    'views/parts/form/button',
    // collections
    'collections/conversation/messages',
    // templates
    'text!templates/modules/conversation/message/message-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
// services
    i18n,
    User,
    // views
    VMenuContext,
    VSupervisorIcon,
    VButton,
    // collections
    CMessages,
    // templates
    TMessageListItem
) {

    var VReplyListItem = Backbone.Epoxy.View.extend({
        template: TMessageListItem,
        events: {
            "click .options-toggle": "showMenuOptions",
            "click": "onClick"
        },
        regions: {
            menu: ".menu-options",
            supervisorIcon: ".supervisor-icon",
        },

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model;

            _.extend(this, {
                view: {},
                timestamp: model.getTimeStampObject(),
                conversation: opt.conversation,
                supervisors: opt.supervisors
            });

            this.listenTo(model, {
                'active': this.setActive,
                'remove': this.remove
            });
        },

        render: function() {
            var model = this.model;
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(_.extend(this.model.toJSON(), {
                isSupervisor: this.userIsSupervisor(),
                isReply: model.get('parentId'),
                isConnectedUser: model.getUser() === User.id

            })), {
                date: this.getTemplatedTimestamp(),
            }));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.renderSupervisorIcon();

            this.applyBindings();

            return this;
        },

        renderSupervisorIcon: function() {
            var view = this.view;
            if (this.userIsSupervisor()) {
                var supervisorIcon = view.supervisorIcon || (view.supervisorIcon = new VSupervisorIcon());
                this.assign(supervisorIcon, this.zone.$supervisorIcon);
            }
        },

        showMenuOptions: function(e) {
            e.preventDefault();
            var view = this.view.menu;
            if (!view) {
                this.view.menu = view = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { caption: "Edit", icon: "sl-icon-pencil", callback: this.onEditAction },
                        //{ caption: "Delete", icon: "sl-icon-trash", callback: this.onDeleteAction }
                    ]),
                });
                this.assign(view, this.zone.$menu);
            }
            view.toggle();
        },

        getTemplatedTimestamp: function() {
            return Mustache.render('<span title="{{timestamp}}">{{fromNow}}</spam>', {
                fromNow: this.timestamp.fromNow(),
                timestamp: this.timestamp.local()
            });
        },

        userIsSupervisor: function() {
            return Boolean(this.supervisors.get(this.model.getUser()));
        },

        ////////////
        // actions //
        ////////////
        onActionClick: function(e, item, menu) {
            e.preventDefault();
        },

        ////////////
        // events //
        ////////////
        onDelete: function(result) {
            if (result) {
                this.model.destroy();
            }
        },

    });

    return VReplyListItem;
});

